import { CanDeactivateFn, Router } from '@angular/router';
import { CanComponentDeactivate } from '../../interfaces/can-component-deactivate';
import { inject } from '@angular/core';

/**
 * Determines if user can exit a route.
 * @param component
 * @param currentRoute
 * @param currentState
 * @param nextState
 */
export const confirmExitGuard: CanDeactivateFn<CanComponentDeactivate> = (
    component,
    currentRoute,
    currentState,
    nextState,
) => {
    const router = inject(Router);
    const navigation = router.currentNavigation();

    if (navigation?.extras.state?.['skipCanDeactivate']) {
        return true; // skip guard
    }

    // Logic for canDeactivate delegated to component
    return component.canDeactivate(currentRoute, currentState, nextState);
};
